import { render } from "./FeedbackTab.vue?vue&type=template&id=1c2baaea&scoped=true&ts=true&lang=pug"
import script from "./FeedbackTab.vue?vue&type=script&lang=ts"
export * from "./FeedbackTab.vue?vue&type=script&lang=ts"

import "./FeedbackTab.vue?vue&type=style&index=0&id=1c2baaea&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2baaea"]])

export default __exports__